import API from '../services/api';
import ApiService from '../utils/api.util';
import { API_CONSTANTS } from "../constants/api.constant";
export default {
    get(pageId) {
        return ApiService.request('get', API_CONSTANTS.API_URI_PREFIX + API.PAGE + '/' + pageId).catch((error) => {
            throw new Error(error);
        });
    },
};
